import { Component } from "react"

import { ErrorElement } from "./errorElement"

export class ErrorBoundary extends Component<{ children: React.ReactNode }, { error: Error | null }> {
    constructor(props: any) {
        super(props)
        this.state = { error: null }
    }

    static getDerivedStateFromError(err: Error) {
        return { hasError: true, error: err }
    }

    componentDidCatch(error: Error): void {
        this.setState({ error })
    }

    render() {
        return this.state.error ? <ErrorElement error={this.state.error} /> : this.props.children
    }
}
